import { render, staticRenderFns } from "./SaleUnitItemsTab.vue?vue&type=template&id=5a481d20&scoped=true"
import script from "./SaleUnitItemsTab.vue?vue&type=script&lang=js"
export * from "./SaleUnitItemsTab.vue?vue&type=script&lang=js"
import style0 from "./SaleUnitItemsTab.vue?vue&type=style&index=0&id=5a481d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a481d20",
  null
  
)

export default component.exports